import { useAction } from '@spazious/react-hooks';
import { actions, selectAppConfig } from '@store';

const appConfigActions = {
  setHotelChain: actions.setHotelChain,
  setSelectedHotels: actions.setSelectedHotels,
  resetSelectedHotels: actions.resetSelectedHotels,
  setSidebarCollapsed: actions.setSidebarCollapsed,
  markTourSeen: actions.markTourSeen,
};

/**
 * Returns the auth state and actions from store.
 */

export const useStoreAppConfig = () => useAction(selectAppConfig, appConfigActions);

export default useStoreAppConfig;
